import { IStory, IPublication } from "@opengov/stories-shared/types";
import { transport } from "@opengov/app-core/transport";

const formItemUrn = (story: IStory, publication?: IPublication): string => {
  if (publication?.id && story.folder?.id) {
    return `urn:opengov:stories:publication/${publication.id}/section/${story.folder.id}/story/${story._id}`;
  } else if (publication?.id) {
    return `urn:opengov:stories:publication/${publication.id}/story/${story._id}`;
  } else if (story.folder?.id) {
    return `urn:opengov:stories:section/${story.folder.id}/story/${story._id}`;
  }
  return `urn:opengov:stories:story/${story._id}`;
}

export const sendStoriesViewedActivity = (story: IStory, userUuid: string, entityId: number, publication?: IPublication): void => {
  const message = {
    id: crypto.randomUUID(),
    source: "urn:opengov:service/stories-service",
    specversion: "1.0",
    type: "com.opengov.user-activity.v1.view",
    datacontenttype: "application/json",
    time: new Date().toISOString(),
    subject: userUuid,
    data: {
      userActivity: {
        itemUrn: formItemUrn(story, publication),
        userId: userUuid,
        entityId: entityId,
        activityTime: new Date().toISOString(),
        itemUrl: window.location.href,
        itemName: story.title,
        itemType: 'Story',
        itemId: story._id,
      }
    }
  };

  if (story.folder?.id) {
    message.data.userActivity['section'] = {
      id: story.folder.id,
      title: story.folder.title,
    };
  }

  if (publication?.id) {
    message.data.userActivity['publication'] = {
      title: publication.title,
      id: publication.id,
    };
  }

  void transport
    .url('/user_activity_service/stories')
    .json(message)
    .post()
}
